import { Paper } from '@mui/material'
import { useParams } from 'react-router-dom'
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'
import { getAccessToken } from '../services/authService'

export const ApiDocs = () => {
    const { endpointType } = useParams<{ endpointType: string }>()
    const addToken = (swaggerUi: any) => {
        const token = getAccessToken()
        swaggerUi.preauthorizeApiKey('bearerAuth', token)
    }
    return (
        <Paper>
            <SwaggerUI url={`/api/v1/swagger/${endpointType}`} onComplete={addToken} />
        </Paper>
    )
}
